import React from 'react';
import {
  Box, Paper, Typography, Avatar, Chip, Stack, IconButton, Tooltip, Badge, Fade
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { modernTheme, getSmartGreeting, formatHours } from './theme';

const DashboardHeader = ({ user, monthlySummary, pendingAdvance, onOpenProfile, isMobile }) => {
  return (
    <Fade in timeout={600}>
      <Paper
        elevation={0}
        sx={{
          background: modernTheme.gradients.card,
          borderRadius: 3,
          p: { xs: 2.5, md: 3.5 },
          mb: 3,
          border: `1px solid ${modernTheme.colors.gray[200]}`,
          boxShadow: modernTheme.shadows.md,
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0, left: 0, right: 0,
            height: 4,
            background: modernTheme.gradients.primary,
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 2, md: 2.5 } }}>
            <Avatar
              sx={{
                width: { xs: 52, md: 64 },
                height: { xs: 52, md: 64 },
                background: modernTheme.gradients.primary,
                fontSize: { xs: '1.25rem', md: '1.5rem' },
                fontWeight: 700,
                boxShadow: modernTheme.shadows.lg,
                border: '3px solid white',
              }}
            >
              {user?.fullName?.charAt(0)?.toUpperCase() || 'U'}
            </Avatar>
            <Box>
              <Typography
                variant={isMobile ? 'h6' : 'h5'}
                sx={{
                  fontWeight: 700,
                  color: modernTheme.colors.gray[900],
                  letterSpacing: '-0.025em',
                  lineHeight: 1.3,
                }}
              >
                {getSmartGreeting()}, {user?.fullName || 'User'}!
              </Typography>
              <Typography variant="body2" sx={{ color: modernTheme.colors.gray[500], fontWeight: 500, mt: 0.25 }}>
                {new Date().toLocaleDateString('vi-VN', {
                  weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
                })}
              </Typography>
              <Box sx={{ mt: 0.75, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                <Chip
                  label={`${formatHours(monthlySummary?.totalHours)} giờ tháng này`}
                  size="small"
                  sx={{
                    bgcolor: modernTheme.colors.gray[100],
                    color: modernTheme.colors.gray[700],
                    fontWeight: 600, fontSize: '0.75rem', height: 26,
                  }}
                />
                <Chip
                  label="Đang hoạt động"
                  size="small"
                  sx={{
                    bgcolor: modernTheme.colors.success,
                    color: 'white',
                    fontWeight: 600, fontSize: '0.75rem', height: 26,
                  }}
                />
              </Box>
            </Box>
          </Box>

          <Stack direction="row" spacing={1}>
            <Tooltip title="Thông báo">
              <IconButton
                sx={{
                  bgcolor: modernTheme.colors.gray[100],
                  color: modernTheme.colors.gray[600],
                  width: 42, height: 42,
                  '&:hover': { bgcolor: modernTheme.colors.gray[200] },
                }}
              >
                <Badge badgeContent={pendingAdvance ? 1 : 0} color="error">
                  <NotificationsIcon fontSize="small" />
                </Badge>
              </IconButton>
            </Tooltip>
            <Tooltip title="Quản lý tài khoản">
              <IconButton
                onClick={onOpenProfile}
                sx={{
                  bgcolor: modernTheme.colors.primary,
                  color: 'white',
                  width: 42, height: 42,
                  '&:hover': { bgcolor: '#1d4ed8', transform: 'scale(1.05)' },
                  transition: 'all 0.2s ease',
                }}
              >
                <ManageAccountsIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>
      </Paper>
    </Fade>
  );
};

export default DashboardHeader;
